"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
var store_1 = require("../store/store");
var setLocale_1 = require("./setLocale");
var reloadAllStrings_1 = require("./reloadAllStrings");
var registerStringPackage_1 = require("./registerStringPackage");
var fetchOptions_1 = require("../utilities/fetchOptions");
exports.default = legacy_1.action("initializeStrings")(function initializeStrings(localeDirectory, initialLocale, prefetchedStrings, fetchOptions) {
    store_1.default.localeDirectory = localeDirectory;
    if (initialLocale) {
        // don't reload from setLocale, since we're reloading below.
        setLocale_1.default(initialLocale, true /* doNotReload */);
    }
    if (prefetchedStrings) {
        Object.keys(prefetchedStrings).forEach(function (packageName) {
            registerStringPackage_1.default(packageName, prefetchedStrings[packageName]);
        });
    }
    if (fetchOptions) {
        fetchOptions_1.setFetchOptions(fetchOptions);
    }
    reloadAllStrings_1.default(store_1.default.currentLocale, !!prefetchedStrings);
});
